import React, { useState, ReactNode, forwardRef, RefCallback } from 'react';

interface InputTextBoxProps {
    label?: string;
    required?: boolean;
    name: string;
    icon?: ReactNode;
    placeholder?: string;
    prefix?: ReactNode;
    value?: string|number;
    type: string;
    handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
    onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    error?: string;
    touched?: boolean;
    login?: boolean;
    disabled?: boolean;
    doubleClick?: () => void;
    inputProps?: React.InputHTMLAttributes<HTMLInputElement>;  // Add inputProps support

}

const InputTextBox = forwardRef<HTMLInputElement, InputTextBoxProps>((props, ref) => {
    const [isFocused, setIsFocused] = useState(false);
    const showError = props.touched && !!props.error;

    return (
        <div className="block text-[12px] w-full">
            {props.label && (
                <div className="flex flex-row mb-0.5">
                    <label
                        className="block font-medium font-public-sans text-slate-900 dark:text-gray-200"
                        htmlFor={props.name}
                    >
                        {props.label}
                    </label>
                    {props.required && <span className="text-red-500 pl-1">*</span>}
                </div>
            )}
            <div className={`flex items-center
                ${props.prefix && showError ? "ring-1 ring-red-600" : "ring-1 shadow-sm "} rounded-sm text-default-500 text-sm font-normal bg-background transition duration-300 
                ${isFocused && props.prefix ? 'ring-green-600 dark:ring-green-400 ring-2' : 'ring-gray-400 dark:ring-sky-900'}
                ${props.disabled && "bg-slate-100 dark:bg-sky-800"}
                ${isFocused && props.prefix && showError && "dark:ring-1 dark:ring-red-600"}`} >
                {props.prefix && (
                    <div className="flex items-center justify-center z-0 text-gray-600 dark:text-gray-400 sticky right-5 px-1.5">
                        {props.prefix}
                    </div>
                )}
                <input
                    type={props.type}
                    className={`placeholder:text-[12px] font-normal placeholder:select-none
                         placeholder:font-light dark:bg-transparent dark:text-gray-300 
                         placeholder:text-gray-400 placeholder:dark:text-gray-500 text-slate-600 text-[12px] font-public-sans w-full focus:outline-none 
                         ${props.login ? "ring-gray-400 placeholder:text-gray-400" : "ring-gray-400 placeholder:text-gray-300"}
                        ${props.prefix ? "my-[2.5px]" : showError ? "ring-1 px-2 !ring-red-600 shadow-sm py-[2.5px] rounded-sm" :
                            "px-2 shadow-sm py-1 ring-1 dark:ring-sky-900 rounded-sm focus:ring-2 focus:ring-green-600 dark:focus:ring-green-400"}`}
                    id={props.name}
                    name={props.name}
                    disabled={props.disabled||false}
                    autoCapitalize="off"
                    autoComplete="off"
                    value={props.value}
                    ref={ref as React.RefCallback<HTMLInputElement>}  
                    onChange={props.handleChange || (() => {})}
                    onBlur={(e) => {
                        props.handleBlur && props.handleBlur(e);
                        setIsFocused(false);
                    }}
                    onDoubleClick={props.doubleClick}
                    onWheel={(e) => e.currentTarget.blur()}  
                    {...props.inputProps}  
                    onKeyPress={props.onKeyPress}
                    placeholder={props.placeholder}
                    onFocus={() => setIsFocused(true)}
                    required={props.required}
                />
            </div>
            {showError && <p className="text-red-500 text-[10px] mt-0.5">{props.error}</p>}
        </div>
     );
    });
export default InputTextBox;
